import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-auth-wrapper',
    templateUrl: './auth-wrapper.component.html',
    styleUrls: ['./auth-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class AuthWrapperComponent {
    @Input()
    title?: string;

    authIcon: SafeHtml;
    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.authIcon = this.iconSanitizer.getIcon('authWrapper');
    }
}
